import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

export const Story = () => {
  const { t } = useLang();
  return (
    <section id="story" className="bg-canvas py-24 md:py-32" data-testid="story">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal className="lg:sticky lg:top-28">
              <h2 className="font-serif font-light text-navy text-4xl md:text-6xl leading-[1.02] tracking-tight">
                {t.story.overline}
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-4">
            {t.story.chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="flex gap-6 md:gap-10 border-b border-gold/30 py-10 last:border-0">
                  <span className="font-serif text-3xl md:text-5xl text-gold leading-none">{c.n}</span>
                  <div>
                    <h3 className="font-serif text-3xl md:text-4xl text-navy">{c.title}</h3>
                    <p className="mt-4 font-light leading-relaxed text-navy/70 max-w-xl">{c.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
